import { useRef, useState } from "react";
import {
  SevenColGrid,
  Wrapper,
  DateControls,
  StyledEvent,
  SeeMore,
  PortalWrapper,
} from "./Calender.styled";
import {
  datesAreOnSameDay,
  getDarkColor,
  getDaysInMonth,
  getMonthYear,
  getSortedDays,
  nextMonth,
  prevMonth,
  range,
  sortDays,
  getMonthData,
} from "./Utils";
import colors from "../../config/colors";
import styled from "styled-components";
import moment from "moment";
import EventRecord from "./EventRecord";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const HeadDays = styled.div`
  && {
    background-color: ${colors.primary};
    color: white;
    padding: 2px;
  }
  /* other styles */
`;

const PlaceholderCell = styled.div`
  background-color: #f0f0f0;
  color: #ccc;
  cursor: default;
`;

export const Calender = ({
  keyss,
  advertiser,
  handleDateClick,
  type,
  eventRecords: events,
  eventdata,
  vehiclesid,
  onEventSubmit,
  fetchevent,
  onEventClick,
}) => {
  // const [currentDate, setCurrentDate] = useState(new Date());
  const [currentDate, setCurrentDate] = useState(() => {
    const now = new Date();
    return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  });

  const [selctedDate, setSelctedDate] = useState(new Date());
  const [events2, setEvents] = useState();

  const dragDateRef = useRef();
  const dragindexRef = useRef();
  const [showPortal, setShowPortal] = useState(false);
  const [portalData, setPortalData] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [eventid, seteventid] = useState();

  const vehicles = () => {
    toast.error("Select Vehicle");
  };

  const drag = (index, e) => {
    dragindexRef.current = { index, target: e.target };
  };
  const onDragEnter = (date, e) => {
    e.preventDefault();
    dragDateRef.current = { date, target: e.target.id };
  };

  const drop = (ev) => {
    ev.preventDefault();

    setEvents((prev) =>
      prev.map((ev, index) => {
        if (index === dragindexRef.current.index) {
          ev.date = dragDateRef.current.date;
        }
        return ev;
      })
    );
  };

  const handleOnClickEvent = (event, day) => {
    setShowPortal(true);
    seteventid(event);
    console.log("event", event);
    setPortalData(event);
  };
  const handlePotalClose = () => setShowPortal(false);

  //   const handleDelete = async () => {

  //     const res = await apiClient.delete(`${eventid}/`);

  // console.log(res)

  //     handlePotalClose();
  //   };
  const handleDelete = async (id) => {
    const res = await apiClient.delete(`/schedule/events/${id}/`);

    fetchevent();
    handlePotalClose();
    if (res.ok) {
      return toast.success(" Event Deleted");
    } else toast.error("Error deleting event:");
  };

  const monthData = getMonthData(currentDate);
  const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  return (
    <>
      <Wrapper style={{ overflow: "auto" }}>
        <DateControls>
          <ion-icon
            onClick={() => prevMonth(currentDate, setCurrentDate)}
            name="arrow-back-circle-outline"
          ></ion-icon>
          {getMonthYear(currentDate)}
          <ion-icon
            onClick={() => nextMonth(currentDate, setCurrentDate)}
            name="arrow-forward-circle-outline"
          ></ion-icon>
        </DateControls>
        <SevenColGrid style={{ backgroundColor: colors.primary }}>
          {DAYS.map((day, index) => (
            <HeadDays
              key={index}
              className="nonDRAG"
              style={{ minWidth: "50px" }}
            >
              {day}
            </HeadDays>
          ))}
        </SevenColGrid>

        <SevenColGrid fullheight={true}>
          {monthData.map((day, index) =>
            day ? (
              <div
                key={index}
                style={{ minWidth: 50, minHeight: 80 }} // Set minimum height
                id={`${currentDate.getFullYear()}/${currentDate.getMonth()}/${
                  day.date
                }`}
                onDragEnter={(e) => onDragEnter(day.fullDate, e)}
                onDragOver={(e) => e.preventDefault()}
                onDragEnd={drop}
                onClick={(e) => {
                  let events2 = [];
                  for (const item of events) {
                    if (
                      datesAreOnSameDay(
                        item.date,
                        new Date(
                          Date.UTC(
                            currentDate.getUTCFullYear(),
                            currentDate.getUTCMonth(),
                            day.date
                          )
                        )
                      )
                    )
                      events2.push(item);
                  }
                  setSelctedDate(
                    new Date(
                      Date.UTC(
                        currentDate.getUTCFullYear(),
                        currentDate.getUTCMonth(),
                        day.date
                      )
                    )
                  );
                  handleDateClick(
                    moment(
                      new Date(
                        Date.UTC(
                          currentDate.getUTCFullYear(),
                          currentDate.getUTCMonth(),
                          day.date
                        )
                      )
                    ).format("D-MMM-YYYY"),
                    events2
                  );
                }}
              >
                <span className="d-flex p-1 h-25 pb-0 justify-content-between">
                  <span
                    className={`nonDRAG ${
                      datesAreOnSameDay(
                        new Date(),
                        new Date(
                          Date.UTC(
                            currentDate.getUTCFullYear(),
                            currentDate.getUTCMonth(),
                            day.date
                          )
                        )
                      )
                        ? "active"
                        : ""
                    }`}
                  >
                    {day.date}
                  </span>
                </span>

                <span className="d-flex justify-content-center">
                  <span style={{ width: "90%" }}>
                    {" "}
                    <EventWrapper
                      date={day.date}
                      events={events}
                      onEventShow={handleDateClick}
                    >
                      {events.map(
                        (ev, index) =>
                          datesAreOnSameDay(
                            new Date(ev.date),
                            new Date(
                              Date.UTC(
                                currentDate.getUTCFullYear(),
                                currentDate.getUTCMonth(),
                                day.date
                              )
                            )
                          ) && (
                            <StyledEvent
                              onDragStart={(e) => drag(index, e)}
                              onClick={() => onEventClick(ev)}
                              className="StyledEvent mb-1"
                              id={`${ev.color} ${ev.title}`}
                              key={ev.title}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "4px 6px",
                                borderRadius: "6px",
                                border: "2px solid #007bff",
                                backgroundColor: "#e6f2ff",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                margin: "2px 0",
                              }}
                            >
                              <div
                                style={{ width: "1.2rem", marginRight: "6px" }}
                              >
                                <img
                                  width="100%"
                                  src={ev?.event_type?.icon_url}
                                  alt=""
                                  style={{
                                    filter:
                                      "drop-shadow(1px 1px 1px rgba(0,0,0,0.3))",
                                  }}
                                />
                              </div>
                              <span
                                style={{
                                  fontSize: "0.85rem",
                                  color: "#333",
                                  fontWeight: "bold",
                                  textShadow: "0.5px 0.5px 1px rgba(0,0,0,0.1)",
                                }}
                              >
                                {ev?.event_type?.request_type}
                              </span>
                            </StyledEvent>
                          )
                      )}
                    </EventWrapper>
                  </span>
                </span>
              </div>
            ) : (
              <PlaceholderCell key={index} />
            )
          )}
        </SevenColGrid>
        {showPortal && (
          <Portal
            {...portalData}
            handleDelete={handleDelete}
            handlePotalClose={handlePotalClose}
            eventid={eventid}
          />
        )}
      </Wrapper>
      {modalShow && (
        <EventRecord
          onEventSubmit={onEventSubmit}
          vehiclesid={vehiclesid}
          eventdata={eventdata}
          fetchevent
          values={{
            keyss,
            show: modalShow,
            type,
            selctedDate,
            setEvents,
            events,
            getDarkColor,
            onHide: () => setModalShow(false),
          }}
        />
      )}
    </>
  );
};

const EventWrapper = ({ children }) => {
  if (children.filter((child) => child).length)
    return (
      <>
        {children}
        {children.filter((child) => child).length > 2 && (
          <SeeMore key="see-more">see more...</SeeMore>
        )}
      </>
    );
};

const Portal = ({ title, date, handleDelete, handlePotalClose, eventid }) => {
  // Format the date and time
  const formattedDate = new Date(eventid.date).toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const formattedTime = eventid.time
    ? new Date(`2000-01-01T${eventid.time}`).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "No time specified";

  return (
    <PortalWrapper>
      <div className="d-flex align-items-center">
        <h2 className="me-2">{eventid?.event_type?.request_type}</h2>
        <img height={"30px"} src={eventid?.event_type.icon_url} alt="" />
      </div>

      <p className="event-datetime">
        <strong>Date:</strong> {formattedDate}
        <br />
        <strong>Time:</strong> {formattedTime}
      </p>
      <p>
        <strong>Address:</strong> {eventid.address}
      </p>

      <ion-icon onClick={handlePotalClose} name="close-outline"></ion-icon>
    </PortalWrapper>
  );
};
